/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createInstance } from '../fn/instance/create-instance';
import { CreateInstance$Params } from '../fn/instance/create-instance';
import { ValidationError } from '../models/validation-error';

@Injectable({ providedIn: 'root' })
export class InstanceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createInstance()` */
  static readonly CreateInstancePath = '/api/instances/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInstance()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInstance$Response(params: CreateInstance$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return createInstance(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInstance$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInstance(params: CreateInstance$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.createInstance$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

}
